/***
 * Created on 2023/11/15
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import PasswordInput from "../form/password_input";
import {useOnChange} from "common/Hook";
import md5 from "blueimp-md5";

function LinkPasswordDialog({showModal, closeModal, socialAccount, metadata, action}) {
    const { t } = useTranslation();
    const {values, onChange} = useOnChange({
        password: '',
        captcha: ''
    })

    const doSocial = () => {
        const data = {
            ...socialAccount,
            password: md5(values.password),
        }
        action.mutate(data);
    }

    return (
        <ModalDialog showModal={showModal} closeModal={closeModal} title={t('@Verify Password@')} submitAction={doSocial}>
            <div className="dialog-content">
                <p className="!mb-16">{t('@We found an account for {email}@')}</p>
                <p className="!mb-16">
                    {t('@Enter your QNAP ID password to link your {platform} account.@')}
                </p>
                <div className="dialog__form-group">
                    <PasswordInput
                        label={t('@Password@')}
                        name='password'
                        value={values.password}
                        placeholder={t('@Password@')}
                        onChange={onChange}
                        showTip={false}
                        showStrength={false}/>
                </div>
            </div>
        </ModalDialog>
    );
}

export default LinkPasswordDialog;